import { Navigate } from "react-router-dom";
import { userIsAdminSelector } from "../../../utils/selectors";
import { useSelector } from "react-redux";
import Spinner from "../../../components/Spinner";

type Props = {
  children: React.ReactNode;
};

const AdminProtectedRoute = ({ children }: Props) => {
    const isAdmin = useSelector((state) => userIsAdminSelector(state));
    const loading = useSelector((state: any) => state.auth.loading); 
 
    if(loading) {
      return <Spinner />;
    }

  if (!isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;